export enum ProgressReduxActions {
  SET_PROGRESS_DATA = "SET_PROGRESS_DATA",
  SET_CURRENT_STEP = "SET_CURRENT_STEP",
  MARK_STEP_COMPLETED = "MARK_STEP_COMPLETED",
  UPDATE_PARENT_STATUS = "UPDATE_PARENT_STATUS",
  RESET_PROGRESS_BY_LOAN_TYPE = "RESET_PROGRESS_BY_LOAN_TYPE",
  SET_SBL_PROGRESS = "SET_SBL_PROGRESS",
  SET_RND_PROGRESS = "SET_RND_PROGRESS",
  SWITCH_LOAN_TYPE = "SWITCH_LOAN_TYPE",
}

const setSblProgress = (payload: any) => ({
  type: ProgressReduxActions.SET_SBL_PROGRESS,
  payload,
});

const setRndProgress = (payload: any) => ({
  type: ProgressReduxActions.SET_RND_PROGRESS,
  payload,
});

const switchLoanType = (loanType: "sbl" | "rnd") => ({
  type: ProgressReduxActions.SWITCH_LOAN_TYPE,
  payload: loanType,
});

const setCurrentStep = (parentId, subItemId, resetOthers = true) => ({
  type: ProgressReduxActions.SET_CURRENT_STEP,
  payload: { parentId, subItemId, resetOthers },
});

const markStepCompleted = (parentId, subItemId, completed = true) => ({
  type: ProgressReduxActions.MARK_STEP_COMPLETED,
  payload: { parentId, subItemId, completed },
});

const resetProgressByLoanType = (loanType: "sbl" | "rnd") => ({
  type: ProgressReduxActions.RESET_PROGRESS_BY_LOAN_TYPE,
  payload: { loanType },
});

export const ProgressActions = {
  setCurrentStep,
  markStepCompleted,
  resetProgressByLoanType,
  setSblProgress,
  setRndProgress,
  switchLoanType,
};
